import { Colors, FInter, FlexBox } from '@brg/ui';
import { FC, useEffect, useMemo, useState } from 'react';
import styled from 'styled-components';
import { API } from '@brg/api';
import closeBtn from '../../../shared/assets/close_icon_black.svg';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCompetitionStage, getStage } from '../../reducers/CompetitonStageSlice';
import { useProfile } from '../../../core/hooks/auth/useProfile';
import { useProject } from '../../hooks/api/useProject';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { computeProject } from '../../helpers/types/computed/ComputedProject';
import { ImageRequest } from '../../constants/imageRequest';
import { computeDesigner } from '../../helpers/computeData';
import { useGetFriendlyUrlParam } from 'shared/hooks/useGetFriendlyUrlParam';

export interface BannerProps {
    isVisible: boolean;
    onDeleteClick?: () => void;
    projectId?: string;
}

const BannerContainer = styled(FlexBox)<BannerProps>`
    display: ${(p) => (p.isVisible ? 'flex' : 'none')};
    width: 100%;
    min-height: 100px;
    background-color: #c7d332;
    position: relative;

    &::before {
        content: '';
        position: absolute;
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 64px 80px 0 0;
        border-color: #2a3034 transparent transparent transparent;
        line-height: 0px;
        _border-color: #2a3034 #000000 #000000 #000000;
        _filter: progid:DXImageTransform.Microsoft.Chroma(color='#000000');
    }

    &::after {
        width: 0;
        height: 0;
        content: '';
        top: -14px;
        left: 14px;
        position: absolute;
        border-style: solid;
        border-width: 0 0 96px 48px;
        border-color: transparent transparent #ffffff transparent;
        line-height: 0;
        _border-color: #000000 #000000 #ffffff #000000;
        _filter: progid:DXImageTransform.Microsoft.Chroma(color='#000000');
        transform: rotate(24deg);
    }
`;

const CloseBannerBtn = styled.div`
    content: '';
    position: absolute;
    width: 24px;
    height: 24px;
    padding: 2.8px;
    background-image: url(${closeBtn});
    background-size: contain;
    background-repeat: no-repeat;
    right: 16px;
    top: 16px;
    cursor: pointer;
`;
const BannerInfoBox = styled(FlexBox)`
    margin: 0 auto;
    width: 1158px;

    justify-content: space-between;
`;

const BannerInfoTitle = styled(FInter.SectionTitle)`
    font-family: Inter, sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 60px;
    line-height: 64px;
    letter-spacing: -0.02em;
`;
const BannerInfoText = styled(FInter.TextDiv)`
    font-family: Inter, sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    line-height: 20px;
    letter-spacing: -0.02em;
    & span {
        font-size: 15px;
        line-height: 20px;
        font-weight: bold;
    }
`;
const ApplyBtn = styled(FlexBox)`
    font-family: Inter, sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    line-height: 20px;
    background-color: ${Colors.zelWhite100};
    cursor: pointer;
    padding: 10px 24px;
    height: 40px;

    & a {
        color: ${Colors.galBlack100};
        text-decoration: none;
    }
`;

const NominationID = '53b364d343994e18b0a184fec3ffbfed';

export const NotificationBanner: FC<BannerProps> = (props) => {
    const { projectId } = props;
    const { i18n } = useTranslation();
    const { stage, stageLocal } = useSelector(getStage);
    const [stageInfo, setStageInfo] = useState<any>();
    const id = useGetFriendlyUrlParam("id");
    const [project] = useProject(id, i18n.language, id);
    const computedProject = useMemo(() => computeProject(project, ImageRequest.image), [project]);

    const dispatch = useDispatch();
    const profile = useProfile();

    useEffect(() => {
        dispatch(fetchCompetitionStage('d544e46b75774d48b3654bdc2f209998'));
    }, [dispatch]);

    useEffect(() => {
        if (stageLocal) {
            setStageInfo(stageLocal);
        }
    }, [stage, stageLocal]);

    const addNomination = () => {
        if (stageInfo.seasonStageEnum === 1) {
            API.fetch(
                `https://api.burgdev.ru/competitions/api/Competition/Apply?NominationID=${NominationID}&ProjectID=${projectId}`,
                {
                    method: 'POST',
                },
            )
                .then((res) => res.json())
                .then(() => {
                    window.location.href = 'https://tellingstories.ffee.site/';
                });
        } else {
            window.location.href = 'https://tellingstories.ffee.site/';
        }
    };
    if (!stageInfo) return null;
    return (
        <BannerContainer isVisible={props.isVisible}>
            <CloseBannerBtn onClick={props.onDeleteClick} />
            <BannerInfoBox offsetTop={20}>
                <FlexBox align={'center'} justify={'space-between'} width={950}>
                    <BannerInfoTitle>Telling Stories Cup</BannerInfoTitle>
                    <BannerInfoText>
                        Open call deadline <FInter.Text>— 10 December 2020</FInter.Text>
                        <br />
                        Winner announsement <FInter.Text>— 25 December 2020</FInter.Text>
                    </BannerInfoText>
                </FlexBox>
                <FlexBox align={'center'}>
                    {(computedProject?.authorId === computeDesigner(profile).accountId || computedProject?.coAuthorIds.includes(computeDesigner(profile).accountId)) && (
                        <ApplyBtn onClick={() => addNomination()}>
                            {stageInfo.userCanApplyProject && `Apply project`}
                        </ApplyBtn>
                    )}
                </FlexBox>
            </BannerInfoBox>
        </BannerContainer>
    );
};
import { Colors, FInter, FlexBox } from '@brg/ui';
import { FC, useEffect, useMemo, useState } from 'react';
import styled from 'styled-components';
import { API } from '@brg/api';
import closeBtn from '../../../shared/assets/close_icon_black.svg';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCompetitionStage, getStage } from '../../reducers/CompetitonStageSlice';
import { useProfile } from '../../../core/hooks/auth/useProfile';
import { useProject } from '../../hooks/api/useProject';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { computeProject } from '../../helpers/types/computed/ComputedProject';
import { ImageRequest } from '../../constants/imageRequest';
import { computeDesigner } from '../../helpers/computeData';
import { useGetFriendlyUrlParam } from 'shared/hooks/useGetFriendlyUrlParam';

export interface BannerProps {
    isVisible: boolean;
    onDeleteClick?: () => void;
    projectId?: string;
}

const BannerContainer = styled(FlexBox)<BannerProps>`
    display: ${(p) => (p.isVisible ? 'flex' : 'none')};
    width: 100%;
    min-height: 100px;
    background-color: #c7d332;
    position: relative;

    &::before {
        content: '';
        position: absolute;
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 64px 80px 0 0;
        border-color: #2a3034 transparent transparent transparent;
        line-height: 0px;
        _border-color: #2a3034 #000000 #000000 #000000;
        _filter: progid:DXImageTransform.Microsoft.Chroma(color='#000000');
    }

    &::after {
        width: 0;
        height: 0;
        content: '';
        top: -14px;
        left: 14px;
        position: absolute;
        border-style: solid;
        border-width: 0 0 96px 48px;
        border-color: transparent transparent #ffffff transparent;
        line-height: 0;
        _border-color: #000000 #000000 #ffffff #000000;
        _filter: progid:DXImageTransform.Microsoft.Chroma(color='#000000');
        transform: rotate(24deg);
    }
`;

const CloseBannerBtn = styled.div`
    content: '';
    position: absolute;
    width: 24px;
    height: 24px;
    padding: 2.8px;
    background-image: url(${closeBtn});
    background-size: contain;
    background-repeat: no-repeat;
    right: 16px;
    top: 16px;
    cursor: pointer;
`;
const BannerInfoBox = styled(FlexBox)`
    margin: 0 auto;
    width: 1158px;

    justify-content: space-between;
`;

const BannerInfoTitle = styled(FInter.SectionTitle)`
    font-family: Inter, sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 60px;
    line-height: 64px;
    letter-spacing: -0.02em;
`;
const BannerInfoText = styled(FInter.TextDiv)`
    font-family: Inter, sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    line-height: 20px;
    letter-spacing: -0.02em;
    & span {
        font-size: 15px;
        line-height: 20px;
        font-weight: bold;
    }
`;
const ApplyBtn = styled(FlexBox)`
    font-family: Inter, sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    line-height: 20px;
    background-color: ${Colors.zelWhite100};
    cursor: pointer;
    padding: 10px 24px;
    height: 40px;

    & a {
        color: ${Colors.galBlack100};
        text-decoration: none;
    }
`;

const NominationID = '53b364d343994e18b0a184fec3ffbfed';

export const NotificationBanner: FC<BannerProps> = (props) => {
    const { projectId } = props;
    const { i18n } = useTranslation();
    const { stage, stageLocal } = useSelector(getStage);
    const [stageInfo, setStageInfo] = useState<any>();
    const id = useGetFriendlyUrlParam("id");
    const [project] = useProject(id, i18n.language, id);
    const computedProject = useMemo(() => computeProject(project, ImageRequest.image), [project]);

    const dispatch = useDispatch();
    const profile = useProfile();

    useEffect(() => {
        dispatch(fetchCompetitionStage('d544e46b75774d48b3654bdc2f209998'));
    }, [dispatch]);

    useEffect(() => {
        if (stageLocal) {
            setStageInfo(stageLocal);
        }
    }, [stage, stageLocal]);

    const addNomination = () => {
        if (stageInfo.seasonStageEnum === 1) {
            API.fetch(
                `https://api.burgdev.ru/competitions/api/Competition/Apply?NominationID=${NominationID}&ProjectID=${projectId}`,
                {
                    method: 'POST',
                },
            )
                .then((res) => res.json())
                .then(() => {
                    window.location.href = 'https://tellingstories.ffee.site/';
                });
        } else {
            window.location.href = 'https://tellingstories.ffee.site/';
        }
    };
    if (!stageInfo) return null;
    return (
        <BannerContainer isVisible={props.isVisible}>
            <CloseBannerBtn onClick={props.onDeleteClick} />
            <BannerInfoBox offsetTop={20}>
                <FlexBox align={'center'} justify={'space-between'} width={950}>
                    <BannerInfoTitle>Telling Stories Cup</BannerInfoTitle>
                    <BannerInfoText>
                        Open call deadline <FInter.Text>— 10 December 2020</FInter.Text>
                        <br />
                        Winner announsement <FInter.Text>— 25 December 2020</FInter.Text>
                    </BannerInfoText>
                </FlexBox>
                <FlexBox align={'center'}>
                    {(computedProject?.authorId === computeDesigner(profile).accountId || computedProject?.coAuthorIds.includes(computeDesigner(profile).accountId)) && (
                        <ApplyBtn onClick={() => addNomination()}>
                            {stageInfo.userCanApplyProject && `Apply project`}
                        </ApplyBtn>
                    )}
                </FlexBox>
            </BannerInfoBox>
        </BannerContainer>
    );
};
